import NothingToExportNotificationContent from "./NothingToExportNotification";
import PasswordFailedNotificationContent from "./PasswordFailedNotification";
import React from "react";
import UpdateFailedNotificationContent from "./UpdateFailedNotification";
import UpdatedSuccessNotificationContent from "./UpdateSuccessNotification";

// top right
const DEFAULT_POSITION = "tc";
const AUTO_DISMISS = 3;

export default class NotificationProvider {
  static getSuccessNotification() {
    return {
      title: <span data-notify="icon" className="pe-7s-check" />,
      message: <span>Success</span>,
      level: "success",
      position: DEFAULT_POSITION,
      autoDismiss: AUTO_DISMISS
    };
  }

  static getWarningNotification() {
    return {
      title: <span data-notify="icon" className="pe-7s-attention" />,
      message: <span>warning</span>,
      level: "warning",
      position: DEFAULT_POSITION,
      autoDismiss: AUTO_DISMISS
    };
  }

  static getFailureNotification() {
    return {
      title: <span data-notify="icon" className="pe-7s-attention" />,
      message: <span>Failed</span>,
      level: "error",
      position: DEFAULT_POSITION,
      autoDismiss: AUTO_DISMISS
    };
  }

  static getSuccessfullUpdate() {
    return {
      title: <span data-notify="icon" className="pe-7s-check" />,
      message: <UpdatedSuccessNotificationContent />,
      level: "success",
      position: DEFAULT_POSITION,
      autoDismiss: AUTO_DISMISS
    };
  }

  static getFailedUpdate() {
    return {
      title: <span data-notify="icon" className="pe-7s-attention" />,
      message: <UpdateFailedNotificationContent />,
      level: "error",
      position: DEFAULT_POSITION,
      autoDismiss: AUTO_DISMISS
    };
  }

  static getPasswordFailureNotification() {
    return {
      title: <span data-notify="icon" className="pe-7s-attention" />,
      message: <PasswordFailedNotificationContent />,
      level: "error",
      position: DEFAULT_POSITION,
      autoDismiss: AUTO_DISMISS
    };
  }

  static getNothingToExportNotification() {
    return {
      title: <span data-notify="icon" className="pe-7s-info" />,
      message: <NothingToExportNotificationContent />,
      level: "warning",
      position: DEFAULT_POSITION,
      autoDismiss: AUTO_DISMISS
    };
  }

  static getDateAfterWarningNotification() {
    return {
      title: <span data-notify="icon" className="pe-7s-info" />,
      message: "Date posterieure à aujourd'hui",
      level: "warning",
      position: DEFAULT_POSITION,
      autoDismiss: AUTO_DISMISS
    };
  }
}
